import Input from './Input';
import React from 'react';
import { Flex, Box } from 'grid-styled';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';

export const LabelInput = ({ label, ...props }) => (
    <Box w={1}>
        <Flex>
            <BoxTemplate textalign="left" w={1 / 2}>
                <Label {...props} textStyle="labelNormal">
                    {label}
                </Label>
            </BoxTemplate>
            <Box w={1 / 2}>
                <Input {...props} />
            </Box>
        </Flex>
    </Box>
);



// WEBPACK FOOTER //
// ./src/form/LabelInput.js